import { Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[appDomChange]',
  standalone: true
})
export class DomChangeDirective implements OnDestroy {
  private changes: MutationObserver;

  @Output()
  public appDomChange = new EventEmitter<MutationRecord>();

  constructor(private elementRef: ElementRef) {
    const element = this.elementRef.nativeElement;

    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) => this.appDomChange.emit(mutation));
    });

    this.changes.observe(element, {
      attributes: false,
      childList: true,
      characterData: false
    });
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }
}
